import { useEffect } from 'react';
import { SignIn } from '@clerk/react';
import type { StepViewProps } from './flow-route-types.js';
import { paths } from './paths.js';
import { useSession } from './use-session.js';

export function StepWelcome({ onNavigate }: StepViewProps) {
  const session = useSession();
  const isAuthenticated = session.status === 'autenticado';

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    onNavigate(paths.store);
  }, [isAuthenticated, onNavigate]);

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8">
      <p className="max-w-2xl text-lg leading-relaxed opacity-80">
        Teste a Marketside por 7 dias, sem pagar nada. Você cadastra seu mercado, escolhe as methods
        de pagamento e entrega e conecta o WhatsApp oficial da loja. Leva poucos minutos.
      </p>

      <div className="grid gap-4 lg:grid-cols-[minmax(0,28rem)_1fr] lg:items-start">
        <div className="rounded-box border border-primary/20 bg-primary/5 p-5">
          <h2 className="text-lg font-semibold">Entre ou crie sua conta para começar</h2>
          <p className="mt-2 opacity-70">
            Use Google ou e-mail para salvar seu cadastro e continuar o teste grátis de 7 dias.
          </p>
        </div>
        <div className="max-w-md">
          <SignIn
            routing="hash"
            withSignUp
            oauthFlow="popup"
            forceRedirectUrl={paths.store}
            fallbackRedirectUrl={paths.store}
            signUpForceRedirectUrl={paths.store}
            signUpFallbackRedirectUrl={paths.store}
          />
        </div>
      </div>
    </div>
  );
}
